import {IRegionListRegion} from "../../../../search/actions/fetch_search_regions_action";
import {rankingLastYear} from "../../../constants/ranking";
import {IRankingCity} from "../../../types/IRankingCity";

interface IGetOfferRankingFormCityOptions {
    cities2023?: IRegionListRegion[];
    cities2022?: IRankingCity[];
    selectedYear?: number;
}

export function getOfferRankingFormCityOptions(params: IGetOfferRankingFormCityOptions) {
    const {cities2023, cities2022, selectedYear} = params;

    if (!cities2023 || !cities2022) {
        return [];
    }

    if (!selectedYear || selectedYear === rankingLastYear) {
        return cities2023.map(({name, slug}) => ({value: slug, label: name}));
    }

    return cities2022.map(({name, slug}) => ({value: slug, label: name}));
}
import {IRegionListRegion} from "../../../../search/actions/fetch_search_regions_action";
import {rankingLastYear} from "../../../constants/ranking";
import {IRankingCity} from "../../../types/IRankingCity";

interface IGetOfferRankingFormCityOptions {
    cities2023?: IRegionListRegion[];
    cities2022?: IRankingCity[];
    selectedYear?: number;
}

export function getOfferRankingFormCityOptions(params: IGetOfferRankingFormCityOptions) {
    const {cities2023, cities2022, selectedYear} = params;

    if (!cities2023 || !cities2022) {
        return [];
    }

    if (!selectedYear || selectedYear === rankingLastYear) {
        return cities2023.map(({name, slug}) => ({value: slug, label: name}));
    }

    return cities2022.map(({name, slug}) => ({value: slug, label: name}));
}
